import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";
import Work7 from "../../assets/work7.png";
import Work8 from "../../assets/work8.png";
import Work9 from "../../assets/work9.png";
const cat = {
  cra: "React",
  hcj: "HTML/CSS/JS",
  mern: "MERN",
};

export const projectsData = [
  {
    id: 9,
    image: Work9,
    title: "Banking System",
    category: cat.mern,
    github: "https://github.com/RajMhatre20/basic-banking-system",
    live: "https://code-bank.onrender.com",
  },
  {
    id: 8,
    image: Work8,
    title: "Pricing Components",
    category: cat.hcj,
    github: "https://github.com/RajMhatre20/pricing-component-with-toggle",
    live: "https://rajmhatre20.github.io/pricing-component-with-toggle/",
  },
  {
    id: 7,
    image: Work7,
    title: "Landing Page",
    category: cat.hcj,
    github: "https://github.com/RajMhatre20/manage-landing-page",
    live: "https://rajmhatre20.github.io/manage-landing-page/",
  },
  {
    id: 6,
    image: Work6,
    title: "Landing Page",
    category: cat.hcj,
    github: "https://github.com/RajMhatre20/bookmark-landing-page",
    live: "https://rajmhatre20.github.io/bookmark-landing-page/",
  },
  {
    id: 5,
    image: Work5,
    title: "Weather App",
    category: cat.hcj,
    github: "https://github.com/RajMhatre20/weather-app",
    live: "https://rajmhatre20.github.io/weather-app/",
  },
  {
    id: 4,
    image: Work4,
    title: "Dice Number Guessing Game",
    category: cat.hcj,
    github: "https://github.com/RajMhatre20/roll-the-dice",
    live: "https://rajmhatre20.github.io/roll-the-dice/",
  },
  {
    id: 3,
    image: Work3,
    title: "Color Generator",
    category: cat.cra,
    github: "https://github.com/RajMhatre20/react-color-generator",
    live: "https://color-generator-pro.netlify.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "GPT-3",
    category: cat.cra,
    github: "https://github.com/RajMhatre20/react-gpt3",
    live: "https://rajmhatre20.github.io/react-gpt3",
  },
  {
    id: 1,
    image: Work1,
    title: "Calculator",
    category: cat.cra,
    github: "https://github.com/RajMhatre20/react-calculator",
    live: "https://rajmhatre20.github.io/react-calculator/",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "React",
  },
  {
    name: "HTML/CSS/JS",
  },
  {
    name: "MERN",
  },
];
